import React, { useState, useEffect, useRef, useLayoutEffect } from 'react';
import Button from '@mui/material/Button';
import Stack from '@mui/material/Stack';
import Box from '@mui/material/Box';
import Grid from '@mui/material/Grid';
import Paper from '@mui/material/Paper';
import Alert from '@mui/material/Alert';
import Tabs from '@mui/material/Tabs';
import Tab from '@mui/material/Tab';
import Dialog from '@mui/material/Dialog';
import AppBar from '@mui/material/AppBar';
import Toolbar from '@mui/material/Toolbar';
import Tooltip from '@mui/material/Tooltip';
import Link from '@mui/material/Link';
import IconButton from '@mui/material/IconButton';
import TextField from '@mui/material/TextField';
import Typography from '@mui/material/Typography';
import CloseIcon from '@mui/icons-material/CloseRounded';
import DeleteIcon from '@mui/icons-material/DeleteRounded';
import Slide from '@mui/material/Slide';
import DOMPurify from 'dompurify';
import axios from 'axios';
import endpoints, { getBackendUrl } from '../../../endpoints';
import { useSelector, useDispatch } from 'react-redux'
import SelectPromptModal from './SelectPromptModal';
import Confirmation from './Confirmation';
import Loading from '../parts/Loading'
import HelpOutlineIcon from '@mui/icons-material/HelpOutlineRounded';
import {setFormValueByElement} from '../../../utils/Utils'
import LibraryBooksIcon from '@mui/icons-material/LibraryBooksRounded';
import SendIcon from '@mui/icons-material/SendRounded';
import ContentCopyIcon from '@mui/icons-material/ContentCopyRounded';
import withAlert from '../../../hoc/withAlerts'

let data = null;

function CoversModal(props) {
    data = props.data;
    
    const [versions, setVersions] = useState([])
    const [prompt, setPrompt] = useState('')
    const [selectedPrompt, setSelectedPrompt] = useState(null)
    const [deleteItem, setDeleteItem] = useState(null)
    const [loading, setLoading] = useState(false)
    
    const [tab, setTab] = useState(null)
    if (props.data == null && tab !== null) {
        setTab(null)
    }
    const token = useSelector((state) => state.auth.token)
    
    const promptRef = useRef()
    
    const rawMarkup = (content) => {
        var rawMarkup = content
        return { __html: DOMPurify.sanitize(rawMarkup) };
    }
    
    const tabChange = (event, newValue) => {
        setTab(newValue);
    };
    
    const getVersions = async (scrollTop, toLastVersion) => {
        if (!data?.id) return 
        
        let uri = getBackendUrl(endpoints.coverletters, token).replace('{feedContentId}', data?.id)
        try {
            let res = await axios.get(uri)
            
            let newIndex = 1;
            let list = [];
            for (let i in res.data.versions) {
                let item = res.data.versions[i];
                item.title = 'Ver. ' + (parseInt(i) + 1)
                list.push(item)
                newIndex = item.version + 1
            }
            
            list.push({
                version: newIndex,
                title: 'New Version',
            })
            
            if (tab === null) {
                if (toLastVersion) {
                    setTab(list[list.length - 2].version)
                } else {
                    setTab(list[0].version)
                }
            } else {
                if (toLastVersion) {
                    setTab(list[list.length - 2].version)
                } else {
                    let find = false
                    for (let i in list) {
                        if (list[i].version === null) {
                            find = true;
                            break;
                        }
                    }
                    if (!find) {
                        let find = false
                        for (let i = list.length - 1; i > -1; i--) {
                            if (list[i].version <= tab) {
                                find = true
                                setTab(list[i].version)
                                break;
                            }
                        }
                        
                        if (!find) {
                            setTab(list[0].version)
                        }
                    }
                }
            }
            
            setVersions(list)
            
            if (scrollTop) {
                setTimeout(function () {
                    let el = document.getElementById('coversList_' + tab)
                    el.scrollTop = 99999
                }, 500)
            }
        } catch (e) {
            //
        }
    }
    
    const deleteHandle = async (result) => {
        if (result) {
            let uri = getBackendUrl(endpoints.coverletters_delete, token)
            uri = uri.replace('{feedContentId}', data.id)
            uri = uri.replace('{version}', deleteItem.id)

            try {
                setLoading(true)
                await axios.delete(uri)
                await getVersions(false)
                setLoading(false)
            } catch (e) {
                setLoading(false)
            }
        }
        
        setDeleteItem(null)
    }
    
    const makeCoverHandler = async () => {
        setLoading(true)
        
        let uri = getBackendUrl(endpoints.coverletters_add, token)
        uri = uri.replace('{feedContentId}', data.id)
        uri = uri.replace('{version}', tab)

        try {
            await axios.post(uri, {
                prompt: promptRef.current.value
            })
            setFormValueByElement(promptRef.current, '')
            await getVersions(true, true)
        } catch (e) {
            
        }
        
        setLoading(false)
    }
    
    const makeBaseCoverHandler = async () => {
        setLoading(true)
        
        let uri = getBackendUrl(endpoints.coverletters_add, token)
        uri = uri.replace('{feedContentId}', data.id)
        uri = uri.replace('{version}', tab)

        try {
            await axios.post(uri, {
                prompt: 'BASE_COVER_LETTER'
            })
            await getVersions(true, true)
        } catch (e) {
            
        }
        
        setLoading(false)
    }
    
    const resizeHandle = () => {
        let s = document.getElementById('coverScroller')
        let h = document.getElementById('coverAppBar')
        let p = document.getElementById('coverLeftPanel')
        let c = document.getElementById('coverCenterPanel')
        if (h && p && c) {
            if (window.innerWidth > 600) {
                s.style.maxHeight = 'calc(100vh - ' + h.offsetHeight + 'px)'
                p.style.maxHeight = 'calc(100vh - ' + h.offsetHeight + 'px)'
                c.style.maxHeight = 'calc(100vh - ' + h.offsetHeight + 'px)'
                c.style.minHeight = 'calc(100vh - ' + h.offsetHeight + 'px)'
            } else {
                s.style.maxHeight = 'calc(100vh - 64px - ' + h.offsetHeight + 'px)'
                p.style.maxHeight = 'none'
                c.style.maxHeight = 'none'
                c.style.minHeight = 'none'
            }
        }
    }
    
    useLayoutEffect(() => {
        resizeHandle()
    })
    
    useEffect(() => {
        window.removeEventListener('resize', resizeHandle);
        window.addEventListener('resize', resizeHandle);
    }, [])
    
    useEffect(() => {
        getVersions()
    }, [data])
        
    return (
        <Dialog 
            open={props.data ? true : false} onClose={() => {props.onClose(false)}} 
            fullScreen
        >
            <AppBar id="coverAppBar" sx={{ position: 'relative' }}>
                <Toolbar>
                    <IconButton
                      edge="start"
                      color="inherit"
                      onClick={props.onClose}
                    >
                        <CloseIcon />
                    </IconButton>
                    <Typography sx={{ ml: 2, flex: 1 }} variant="h6" component="div">
                        Cover Letters Factory
                    </Typography>
                    <Button 
                        href={data?.apply_url} 
                        target="_blank" 
                        color="inherit"
                    >
                        Apply
                    </Button>
                </Toolbar>
            </AppBar>
            <Box id="coverScroller" sx={{maxHeight: '100vh', overflowY: 'auto'}}>
                <Grid container spacing={0}>
                    <Grid item lg={4} md={5} sm={6} xs={12} sx={{backgroundColor: 'rgba(0,0,0,0.05)'}}>
                        <Stack id="coverLeftPanel" spacing={2} sx={{p:3, overflow: 'auto'}}>
                            <Typography variant="h6" gutterBottom>
                                {props.data?.title}
                            </Typography>
                            <div
                                dangerouslySetInnerHTML={rawMarkup(props.data?.content)}
                            />
                        </Stack>
                    </Grid>
                    <Grid item lg={8} md={7} sm={6} xs={12}>
                        <Stack id="coverCenterPanel" spacing={1}>
                            <Box sx={{ width: '100%', px: 2 }}>
                                <Tabs value={tab} onChange={tabChange}>
                                    <Tab value={null} sx={{position: 'absolute', zIndex: -9999}} key={null}/>
                                    {versions?.map((item) => {
                                        return (
                                            <Tab 
                                                value={item.version} 
                                                label={item.title} 
                                                key={item.version} 
                                            />
                                        )
                                    })}
                                </Tabs>
                            </Box>
                            {versions?.map(({version, items}) => {
                                return (
                                    <Stack 
                                        id={'coversList_' + version}
                                        key={'coversList_' + version}
                                        spacing={2}
                                        sx={(tab == version ? {flexGrow:1, overflow: 'auto', p:2, pt: 1} : {display: 'none'})}
                                    >
                                        {items?.map(({id, content, prompt}) => {
                                            return (
                                                <Stack 
                                                    key={'coversListItem_' + id}
                                                    spacing={1}
                                                >
                                                    <Alert 
                                                        severity="warning"
                                                        iconMapping={{
                                                            warning: <HelpOutlineIcon fontSize="inherit" />,
                                                        }}
                                                        action={
                                                            <Tooltip
                                                                title="Delete Prompt and Cover Letter"
                                                            >
                                                                <IconButton
                                                                    aria-label="close"
                                                                    color="inherit"
                                                                    size="small"
                                                                    onClick={() => {
                                                                        setDeleteItem({id: id})
                                                                    }}
                                                                >
                                                                    <DeleteIcon />
                                                                </IconButton>
                                                            </Tooltip>
                                                        }
                                                    >
                                                    {prompt}
                                                    </Alert>
                                                    <Alert 
                                                        severity="info" 
                                                        sx={{whiteSpace: 'pre-line'}}
                                                        action={
                                                            <Tooltip
                                                                title="Copy Cover Letter to Clipboard"
                                                            >   
                                                                <span>
                                                                    <IconButton onClick={() => {
                                                                        navigator.clipboard?.writeText(content)
                                                                        props.showAlert('The cover letter has been successfully copied to the clipboard.', 'success')
                                                                    }}>
                                                                        <ContentCopyIcon/>
                                                                    </IconButton>
                                                                </span>
                                                            </Tooltip>
                                                        }
                                                    >
                                                        {content}
                                                    </Alert>
                                                </Stack>
                                            )
                                        })}
                                        {items?.length ? null :
                                        <Stack direction="row">
                                            <Button 
                                                variant="contained"
                                                color="primary"
                                                onClick={makeBaseCoverHandler}
                                            >
                                                Make Base Cover Letter
                                            </Button>
                                        </Stack>
                                        }
                                    </Stack>
                                )
                            })}
                            {tab !== null ?
                            <Stack direction="row" sx={{p:2, py: 0}}>
                                <Tooltip title="Prompts Library">
                                    <IconButton
                                        onClick={() => {setSelectedPrompt({})}}
                                    >
                                        <LibraryBooksIcon />
                                    </IconButton>
                                </Tooltip>
                                <Stack sx={{flexGrow:1}} />
                                <Tooltip title="Make the Cover">
                                    <span>
                                        <IconButton
                                            onClick={makeCoverHandler} 
                                            disabled={prompt ? false : true}
                                        >
                                            <SendIcon />
                                        </IconButton>
                                    </span>
                                </Tooltip>
                            </Stack>
                            : null }
                            {tab !== null ?
                            <Stack spacing={2} direction="row" sx={{p:2, pt:0}}>
                                <TextField
                                    fullWidth 
                                    name="prompt" 
                                    label="Prompt" 
                                    variant="filled" 
                                    inputRef={promptRef}
                                    multiline
                                    rows={3}
                                    onChange={(e) => {setPrompt(e.target.value)}}
                                />
                            </Stack>
                            : null }
                        </Stack>
                    </Grid>
                </Grid>
            </Box>
            <SelectPromptModal 
                selectedPrompt={selectedPrompt}
                onClose={() => {setSelectedPrompt(null)}}
                onSelect={(item) => {
                    setFormValueByElement(promptRef.current, item.content)
                    setSelectedPrompt(null)
                }}
            />
            <Confirmation data={deleteItem} onResponse={deleteHandle} />
            {loading ? <Loading /> : null }
        </Dialog>
    )
}

export default withAlert(CoversModal)